import { gql } from "@apollo/client"
import { useMutation } from "@oysterhr/core"
import { TodoTasksTaskFragment } from "~/shared/fragments/TodoTasksTaskFragment"
import { Mutation, MutationToggleDepositBeforeLiabilityArgs } from "@oysterhr/schema"

const HIRING_FTE_STAFF_TOGGLE_EMPLOYMENT_DEPOSIT_BEFORE_LIABILITY = gql`
  mutation HiringFTEStaffToggleEmploymentDepositBeforeLiability(
    $input: ToggleDepositBeforeLiabilityInput!
  ) {
    toggleDepositBeforeLiability(input: $input) {
      engagement {
        id
        depositBeforeLiability
        employment {
          id
          depositBeforeLiability
          hiring {
            id
            hiringProcess {
              staffTasks {
                ...TodoTasksTaskDetails
              }
            }
          }
        }
      }
      errors
    }
  }

  ${TodoTasksTaskFragment}
`

export function useToggleEmploymentDepositBeforeLiability() {
  return useMutation<
    Mutation["toggleDepositBeforeLiability"],
    MutationToggleDepositBeforeLiabilityArgs
  >(HIRING_FTE_STAFF_TOGGLE_EMPLOYMENT_DEPOSIT_BEFORE_LIABILITY, {
    handlePayloadErrors: true,
  })
}
